export default __webpack_public_path__ + "static/media/six.04a89b5f.svg";